module.exports = __webpack_public_path__ + "img/svg/background-invite-friend.171e967e35ef7ca1fd658afcd0798f0b.svg";